exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "header-ss{display:block}header-ss header div{display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-align:center;-moz-align-items:center;align-items:center;-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between;height:111px;max-width:1200px;padding:33px 30px;width:100%}@media(max-width:1120px){header-ss header div{padding:33px 0}}header-ss header div h1{font-size:25px;font-weight:500;margin:0;text-transform:uppercase}@media(max-width:1120px){header-ss header div h1{font-size:22px}}header-ss header div img.header-image-left{height:70px}header-ss header div img.header-image-right{height:50px}header-ss header h2{font-size:15px;font-weight:400;text-align:center;color:#777676;margin-top:0;margin-bottom:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/social-security.module/features/socialSecurity/headerSS/headerSS.scss
// module id = 2332
// module chunks = 0